<template>
  <div>
    <button @click="addSymbol('a')">Add A</button>
    {{str}}
  </div>
</template>

<script>
import eventBus from './eventBus'


export default {
    created() {
        eventBus.$on('four::add-letter',this.addSymbol)
    },
    beforeDestroy() {
        eventBus.$off('four::add-letter',this.addSymbol)
    },
    data() {
        return {
            str:''
        }
    },
    methods: {
        addSymbol(sym){
            this.str += sym;
        }
    },
}
</script>

<style>

</style>